import React from "react";
import { useDispatch } from "react-redux";
import { Icon } from "antd";

import Tag from "./tag";
import { controlModal } from "../../../store/actions/voting.actions";
import useRootEntity from "../../../hooks/useRootEntity";
import useAllowChanges from "../../../hooks/useAllowChanges";
import House from "./house";

const Street = ({ streetObj, setFieldsValue, companyId }) => {
	const dispatch = useDispatch();
	const rootEntity = useRootEntity(streetObj.streetId, "houses", companyId);
	const changeable = useAllowChanges();
	return (
		<div className="street">
			<span className="texts">ул. {streetObj.street}</span>
			<div className="tags-row">
				{streetObj.houses.map((houseObj) => {
					return (
						<House
							houseObj={houseObj}
							setFieldsValue={setFieldsValue}
							key={houseObj.houseId}
						/>
					);
				})}
				{changeable && (
					<Tag
						tagType={"tag-edit"}
						onClick={() => {
							dispatch(controlModal(true, "houses", rootEntity, companyId));
						}}
					>
						<Icon type="edit" />
					</Tag>
				)}
			</div>
		</div>
	);
};
export default Street;
